import { z, pipe } from "zod";

const LOGIN_PASSWORD_ALLOWED_SPECIAL = ["@", "#", "$", "%", "^", "&", "+", "=", "!", "*"].join("");

export const VENDOR_NEW_PASSWORD_RULE_HINT =
  "La password deve avere almeno 8 caratteri, una maiuscola, una minuscola, un numero e un carattere speciale tra @ # $ % ^ & + = ! *";

export const recoverPasswordEmailSchema = pipe(
  z.string().trim().min(1, { message: "Inserisci l'email." }),
  z.email({ message: "Inserisci un formato email valido." })
);

export const vendorNewPasswordSchema = z
  .string()
  .min(1, { message: "Inserisci la password." })
  .min(8, { message: "La password deve avere almeno 8 caratteri." })
  .superRefine((val, ctx) => {
    let hasUpper = false;
    let hasLower = false;
    let hasDigit = false;
    let hasSpecial = false;
    for (let i = 0; i < val.length; i += 1) {
      const c = val.charAt(i);
      if (c >= "A" && c <= "Z") {
        hasUpper = true;
      }
      if (c >= "a" && c <= "z") {
        hasLower = true;
      }
      if (c >= "0" && c <= "9") {
        hasDigit = true;
      }
      if (LOGIN_PASSWORD_ALLOWED_SPECIAL.includes(c)) {
        hasSpecial = true;
      }
    }
    if (!hasUpper || !hasLower || !hasDigit || !hasSpecial) {
      ctx.addIssue({
        code: "custom",
        message: VENDOR_NEW_PASSWORD_RULE_HINT,
      });
    }
  });
